import React, { Component } from "react";
import "./App.css";

import darkBaseTheme from "material-ui/styles/baseThemes/darkBaseTheme";
import lightBaseTheme from "material-ui/styles/baseThemes/lightBaseTheme";
import { MuiThemeProvider, getMuiTheme } from "material-ui/styles";
import injectTapEventPlugin from "react-tap-event-plugin";
injectTapEventPlugin(); // Needed for onTouchTap http://stackoverflow.com/a/34015469/988941
import {
  AppBar,
  Avatar,
  Card,
  CardActions,
  CardText,
  SelectField,
  CardTitle,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  FlatButton,
  FloatingActionButton,
  FontIcon,
  List,
  ListItem,
  TimePicker,
  Menu,
  MenuItem,
  Paper,
  RaisedButton,
  Subheader,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TextField,
  makeSelectable
} from "material-ui";

import TimeAgo from "react-timeago";

import * as firebase from "firebase";
firebase.initializeApp({
  apiKey: "AIzaSyDJDkb10NV1qAulDubkq4bDsEAVaXYsW_4",
  authDomain: "webcron-9a8a0.firebaseapp.com",
  databaseURL: "https://webcron-9a8a0.firebaseio.com",
  projectId: "webcron-9a8a0",
  storageBucket: "webcron-9a8a0.appspot.com",
  messagingSenderId: "847368514261"
});

class App extends Component {
  state = { user: null, args: {} };

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      const userAttrs = user
        ? ["displayName", "email", "photoURL", "providerId", "uid"].reduce(
            (o, k) => {
              o[k] = user[k];
              return o;
            },
            {}
          )
        : null;
      this.setState({ user: userAttrs });

      if (user) {
        // /${user.uid}/
        this.taskRef = firebase.database().ref(`/tasks`);
        window.taskRef = this.taskRef; // for console hacking
        this.taskRef.once("value", snap => {
          const val = snap.val();
          const tasks = {};
          Object.keys(val || {}).map(k => tasks[k] = val[k]);
          this.setState({ tasks });

          const updateTask = snap => {
            const val = snap.val();
            const tasks = { ...this.state.tasks };
            tasks[snap.key] = { ...val, id: snap.key };
            this.setState({ tasks });
          };
          this.taskRef.on("child_added", updateTask);
          this.taskRef.on("child_changed", updateTask);
          this.taskRef.on("child_removed", snap => {
            const tasks = { ...this.state.tasks };
            delete tasks[snap.key];
            this.setState({ tasks });
          });
        });
      } else {
        this.taskRef = null;
        this.taskRef.off();
      }
    });
  }

  componentWillUnmount() {
    this.taskRef.off();
  }

  signin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider);
  }

  signout() {
    firebase.auth().signOut();
  }

  renderAppBar() {
    return (
      <AppBar
        title="WebCron"
        iconElementRight={
          this.state.user && this.state.user.displayName
            ? <FlatButton
                label={this.state.user.displayName}
                onTouchTap={this.signout.bind(this)}
              />
            : <FlatButton label="Login" onTouchTap={this.signin.bind(this)} />
        }
        onLeftIconButtonTouchTap={() => this.setState({ showDrawer: true })}
      />
    );
  }

  setArgs(args) {
    this.setState({ args: Object.assign({ ...this.state.args }, args) });
  }

  addTask() {
    const date = this.refs.atDate.state.date;
    const time = this.refs.atTime.state.time;
    const at = +new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDay(),
      time.getHours(),
      time.getMinutes()
    );
    const task = { at, args: this.state.args, type: this.state.type };
    this.taskRef.push(task);
    this.setState({ args: {}, type: null });
  }

  renderTask(task) {
    return (
      <Card key={task.id}>
        <CardTitle title={task.type} subtitle={<TimeAgo date={task.at} />} />
        <CardText><pre>{JSON.stringify(task.args, null, 2)}</pre></CardText>
        <CardActions>
          <RaisedButton
            secondary={true}
            label="Remove"
            onTouchTap={() => this.taskRef.child(task.id).remove()}
          />
        </CardActions>
      </Card>
    );
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
        <div>
          {this.renderAppBar()}
          <Card>
            <CardTitle title="New Task" />
            <CardText>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                  <SelectField
                    floatingLabelText="Type"
                    value={this.state.type}
                    onChange={(e, i, type) => this.setState({ type })}
                  >
                    <MenuItem value={"tweet"} primaryText="tweet" />
                    <MenuItem value={"sms"} primaryText="sms" />
                    <MenuItem value={"email"} primaryText="email" />
                  </SelectField>

                  <DatePicker
                    floatingLabelText="Date"
                    mode="landscape"
                    defaultDate={new Date()}
                    autoOk={true}
                    minDate={new Date()}
                    ref="atDate"
                  />
                  <TimePicker
                    format="24hr"
                    floatingLabelText="Time"
                    defaultTime={new Date()}
                    autoOk={true}
                    ref="atTime"
                    // value={this.state.atTime}
                    // onChange={(e, atTime) => this.setState({ atTime })}
                  />
                </div>
                <div style={{ flex: 1 }}>

                  {this.state.type === "tweet" &&
                    <TextField
                      value={this.state.args.status}
                      onChange={(e, status) => this.setArgs({ status })}
                      floatingLabelText="Status"
                      multiLine={true}
                    />}

                  {this.state.type === "sms" &&
                    <div>
                      <TextField
                        value={this.state.args.to}
                        onChange={(e, to) => this.setArgs({ to })}
                        floatingLabelText="To"
                      />
                      <br />
                      <TextField
                        value={this.state.args.body}
                        onChange={(e, body) => this.setArgs({ body })}
                        floatingLabelText="Body"
                        multiLine={true}
                      />
                    </div>}

                  {this.state.type === "email" &&
                    <div>
                      <TextField
                        value={this.state.args.to}
                        onChange={(e, to) => this.setArgs({ to })}
                        floatingLabelText="To"
                      />
                      <br />
                      <TextField
                        value={this.state.args.subject}
                        onChange={(e, subject) => this.setArgs({ subject })}
                        floatingLabelText="Subject"
                      />
                      <br />
                      <TextField
                        value={this.state.args.text}
                        onChange={(e, text) => this.setArgs({ text })}
                        floatingLabelText="Text"
                        multiLine={true}
                      />
                      <br />
                      <TextField
                        value={this.state.args.html}
                        onChange={(e, html) => this.setArgs({ html })}
                        floatingLabelText="HTML"
                        multiLine={true}
                      />
                    </div>}

                </div>
              </div>
            </CardText>
            <CardActions>
              <RaisedButton
                primary={true}
                label="Save"
                onTouchTap={this.addTask.bind(this)}
              />
              <FlatButton label="Cancel" />
            </CardActions>
          </Card>

          {Object.keys(this.state.tasks || {})
            .map(id => this.state.tasks[id])
            .sort((a, b) => a.at - b.at)
            .map(task => this.renderTask(task))}
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js